import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonDialogSettings } from '../common-dialog-settings.interface';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    standalone: false,
})
export class ConfirmDialogComponent implements OnInit {
    public constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public settings: CommonDialogSettings
    ) {}

    public ngOnInit(): void {}

    public onAceptar(): void {
        this.dialogRef.close();

        if (this.settings.onAceptar) {
            this.settings.onAceptar(true);
        }
    }

    public onCancelar(): void {
        this.dialogRef.close();

        if (this.settings.onCancelar) {
            this.settings.onCancelar(false);
        }
    }
}
